import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";
import { GetUserLogin } from "../../../../services";
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class Edit extends Component {
  constructor(props) {
    super(props);
    let userdata = this.props.location.state;
    this.state = {
      isLoaded: false,
      id: userdata.id,
      email: userdata.email,
      fullName: userdata.fullName || "",
      phone: userdata.phone || "",
      password: null,
      confirmPassword: null,
      status: userdata.status === true || userdata.status === 1 ? "1" : "0",
      role: userdata.role,
    };
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleBack(e) {
    this.props.history.goBack();
  }

  handleSubmit = async () => {
    this.setState({ isLoaded: true });

    const {
      id,
      fullName,
      email,
      phone,
      password,
      confirmPassword,
      status,
      role,
    } = this.state;

    if (password !== confirmPassword) {
      alert("Passwords don't match");
      this.setState({ isLoaded: false });
      return;
    }

    const data = {
      id,
      fullName,
      email,
      phone,
      password,
      status: status === "1", // convert to boolean
      role,
    };

    const user = await GetUserLogin.getUserUpdate(data);
    this.setState({ isLoaded: false });

    if (user) {
      NotificationManager.success("Update success", "Message");
      this.props.history.goBack();
    } else {
      NotificationManager.error("Check field", "Input");
    }
  };

  render() {
    const {
      isLoaded,
      fullName,
      email,
      phone,
      role,
      password,
      confirmPassword,
      status,
    } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9">
            <h2 className="mt-30 page-title">Update User</h2>
          </div>
          <div className="col-lg-5 col-md-3 back-btn">
            <Button variant="contained" onClick={() => this.handleBack()}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>

        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item">User</li>
        </ol>

        <Paper className="user-management" style={{ padding: "1rem" }}>
          {isLoaded && <Loader />}

          <div className="row">
            <div className="col-md-6 form-group">
              <label>Full Name</label>
              <input
                type="text"
                className="form-control"
                name="fullName"
                value={fullName}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Phone</label>
              <input
                type="text"
                className="form-control"
                name="phone"
                value={phone}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Status</label>
              <select
                className="form-control"
                name="status"
                value={status}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="col-md-6 form-group">
              <label>Email</label>
              <input
                type="text"
                className="form-control"
                name="email"
                value={email}
                disabled
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Role</label>
              <select
                className="form-control"
                name="role"
                value={role}
                onChange={(e) => this.handleChange(e)}
              >
                <option value="">Select Role</option>
                <option value="admin">Admin</option>
                <option value="HR">HR</option>
                <option value="customercare">Customer Care</option>
                <option value="operation">Operation</option>
                <option value="emp">Emp</option>
              </select>
            </div>

            <div className="col-md-6 form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={password}
                onChange={(e) => this.handleChange(e)}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                className="form-control"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
          </div>

          <button
            className="btn btn-success col-sm-3 mt-3 py-2"
            onClick={this.handleSubmit}
          >
            Update
          </button>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/user/edit/index.js